import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setParkPlacardFee } from '../../redux/modules/registration';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import parkPlacards from '../../modules/data/park-placards';
import TextInput from '../../components/TextInput';

class ParkPlacards extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const selectedValue = event.target.value;
    const parts = selectedValue.split('|');
    const name = parts[0];
    const fee = parts[1];
    this.props.setParkPlacardFee(name, precise(fee), selectedValue);
  }

  render() {
    const { parkPlacardFee, parkPlacardSelectedValue, parkPlacardName } = this.props;
    return (
      <div className="Row Registration-transferFeeRow">

        <TextInput
          id="Rsub8"
          data-id="parkPlacardFee"
          tooltip="Park Placard Total"
          value={parkPlacardFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          initial={['No Park Placard', 'No Park Placard|0']}
          id="parkPlacards"
          tooltip="Select a Park Placard"
          options={parkPlacards}
          onChange={this.onValueSelect}
          selectedValue={parkPlacardSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{parkPlacardName}</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    parkPlacardFee: state.registration.parkPlacardFee,
    parkPlacardName: state.registration.parkPlacardName,
    parkPlacardSelectedValue: state.registration.parkPlacardSelectedValue,
    parkPlacardSelectedValueLabel: state.registration.parkPlacardSelectedValueLabel,
  };
};

export default connect(mapStateToProps, { setParkPlacardFee })(ParkPlacards);
